import axios from 'axios'
export default {
  // // 查询用户信息
  // getMainInfo (params) {
  //   return axios.post('/api/rendering/admin/base/queryLoginAdmin', params)
  // },
  // 查询地区
  getALlArea(params) {
    return axios.post('/api/rendering/admin/front/user/queryArea', params)
  },
  // 查询分配地址
  getMountPath(params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/getMountPathByPlatform', params)
  },
  // 查询软件类型
  getSoftware(params) {
    return axios.post('/api/rendering/admin/front/user/detailinfo/queryTaskCgInfo', params)
  },
  // 根据软件查询版本
  getSoftwareVersion(params) {
    return axios.post('/api/rendering/admin/task/config/queryCgVersionByCgId', params)
  },
  // 省份列表查询
  getProvinceList(params) {
    return axios.post('/api/rendering/admin/front/user/listProvince', params)
  },
  // 城市列表查询
  getCityList(params) {
    return axios.post('/api/rendering/admin/front/user/queryCity', params)
  },
  getStatusConfig(params) {
    return axios.post('/api/rendering/admin/base/pay/recharge/getPayRelationConf', params)
  },
  // 获取节点机状态详情
  getNodeStatusDetail(params) {
    return axios.post('/api/rendering/admin/task/analyse/getNodeStatusDetail', params)
  },
  // // 获取所有插件平台
  // getPlatforms (params) {
  //   return axios.post('/api/rendering/admin/task/common/getPlatforms', params)
  // },
  // 获取所有插件平台
  getPlatformStatus(params) {
    return axios.post('/api/rendering/admin/task/common/getPlatformStatus', params)
  },
  // 查询所有权限
  getAllPermission(params) {
    return axios.post('/api/rendering/admin/base/user/role/queryAllPermissions', params)
  },
  // 查询用户信息
  getUserInfo(params) {
    return axios.post('/api/rendering/admin/base/queryLoginAdmin', params)
  },
  // 查询所有的约束
  getConstraintExceptStoarge(params) {
    return axios.post('/api/rendering/admin/task/config/constraintExceptStoarge', params)
  },
  // 任务页面查询所有约束
  getAllConstraints(params) {
    return axios.post('/api/rendering/admin/task/config/constraintTypeList', params)
  },
  // 获取所有平台号
  getAllPlatforms(params) {
    return axios.post('/api/rendering/admin/task/common/queryPlatforms', params)
  },
  // 最新管理员公告
  getNewAdminBulletin(params) {
    return axios.post('/api/rendering/admin/task/homepage/getNewAdminBulletin', params)
  },
  // 查询平台渲染任务帧状态统计
  queryRenderingTaskOfPlatformStat(params) {
    return axios.post('/api/rendering/admin/task/homepage/queryRenderingTaskOfPlatformStat', params)
  },
  // 查询平台节点机状态统计
  queryNodeStatistics(params) {
    return axios.post('/api/rendering/admin/task/homepage/queryNodeStatistics', params)
  },
  // 查询作业帧群组状态统计
  queryTaskFrameGroupStat() {
    return axios.post('/api/rendering/admin/task/homepage/queryTaskFrameGroupStat')
  },
  // 查询节点机群组状态统计
  getNodeCategoryStatusStatistics() {
    return axios.post('/api/rendering/admin/task/homepage/getNodeCategoryStatusStatistics')
  },
  // 查看群组节点机分布
  queryNodeCountByCategory(params) {
    return axios.post('/api/rendering/admin/task/homepage/queryNodeCountByCategory', params)
  },
  // 查看存储报警统计
  getStorageStatByIP(params) {
    return axios.post('/api/rendering/admin/task/homepage/getStorageStatByIP', params)
  },
  // 查询首页存储统计
  queryStorageStat(params) {
    return axios.post('/api/rendering/admin/task/homepage/queryStorageStat', params)
  },
  // 首页平台内租赁用户统计
  getRentalUserStatistics(params) {
    return axios.post('/api/rendering/admin/task/homepage/getLeaseNodeDistributionStatistics', params)
  },
  // 平台全部软件信息查询
  getCgInfoMap(params = {}) {
    return axios.post('/api/rendering/admin/task/config/getCgInfoMap', params)
  },
  // 获取jira的入口
  getJiraLoginUrl(params = {}) {
    return axios.post('/api/rendering/admin/base/getJiraLoginUrl', params)
  },
  // 获取GPU使用率数据
  getNodeGpuDetail(params) {
    return axios.post('/api/rendering/admin/task/analyse/getNodeGpuDetail', params)
  },
  // 查询插件类型和版本
  getPlugin(params) {
    return axios.post('/api/rendering/admin/task/config/getPluginByCondition', params)
  },
  // 查询当前业务线
  queryLoginAdmin() {
    return axios.post('/api/rendering/admin/base/queryLoginAdmin')
  },
  // 节点机性能监控
  showNodeRenderProperty(params) {
    return axios.post('/api/rendering/admin/task/rendering/showNodeRenderProperty', params)
  },
  getGlobalSearchNodeList(nodeIp) {
    return axios.post('/api/rendering/admin/task/common/getGlobalSearchNodeList', { nodeIp })
  },
  // 查询帧数详情
  queryCgCountDetail(params) {
    return axios.post('/api/rendering/admin/front/user/frame/queryCgCountDetail', params)
  },
  // 查询软件计算量详情
  queryCgDurationDetail(params) {
    return axios.post('/api/rendering/admin/front/user/frame/queryCgDurationDetail', params)
  },
  // 查询软件扣费详情
  queryCgFeeDetail(params) {
    return axios.post('/api/rendering/admin/front/user/frame/queryCgFeeDetail', params)
  },
  // 完成帧数趋势图
  queryCgFrameCountTrend(params) {
    return axios.post('/api/rendering/admin/front/user/frame/queryCgFrameCountTrend', params)
  },
  // 帧计算量趋势图
  queryCgFrameDurationTrend(params) {
    return axios.post('/api/rendering/admin/front/user/frame/queryCgFrameDurationTrend', params)
  },
  // 帧扣费趋势图
  queryCgFrameFeeTrend(params) {
    return axios.post('/api/rendering/admin/front/user/frame/queryCgFrameFeeTrend', params)
  },
  // 按平台/软件查询帧状态数据
  queryTaskFrameStatusData(params) {
    return axios.post('/api/rendering/admin/front/user/frame/queryTaskFrameStatusData', params)
  },
  // 查询帧状态明细
  queryTaskFrameStatusDetail(params) {
    return axios.post('/api/rendering/admin/front/user/frame/queryTaskFrameStatusDetail', params)
  },
  // 查询帧状态分布
  queryTaskFrameStatusTrend(params) {
    return axios.post('/api/rendering/admin/front/user/frame/queryTaskFrameStatusTrend', params)
  },
  queryFrameCountTrend(params) {
    return axios.post('/api/rendering/admin/front/user/frame/queryFrameCountTrend', params)
  },
  queryFrameFeeTrend(params) {
    return axios.post('/api/rendering/admin/front/user/frame/queryFrameFeeTrend', params)
  },
  queryFrameDurationTrend(params) {
    return axios.post('/api/rendering/admin/front/user/frame/queryFrameDurationTrend', params)
  },
  exportFrameAllDetail(params) {
    return axios.post('/api/rendering/admin/front/user/frame/exportFrameAllDetail', params)
  },
  exportTaskFrameStatusDetail(params) {
    return axios.post('/api/rendering/admin/front/user/frame/exportTaskFrameStatusDetail', params)
  },
  // 根据软件id查询模板字段
  queryTemplateFieldByCgId(params) {
    return axios.post('/api/rendering/admin/task/config/user/queryTemplateFieldByCgId', params)
  },
  // 获取GPU卡数列表
  getGpuNum() {
    return axios.post('/api/rendering/admin/task/rendering/getGpuNum')
  },
}
